import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';
import { FlexProps } from '../../flex';

interface IHeroWrapperProps {
	imageSrc?: string;
	children?: ReactNode;
	contentProps?: FlexProps;
}

// The hero header (cover image + large in-card title on a white surface) was removed:
// the page title now comes from the breadcrumbs, and the white surface didn't respect
// the dark theme. This renders its children directly on the themed page background, and
// fills the available height (flex column) so content can stretch to the viewport.
export const HeroWrapper: FC<IHeroWrapperProps> = ({ children, contentProps, imageSrc: _imageSrc }) => (
	<Box
		sx={{ width: '100%', flexGrow: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
		{...contentProps}
	>
		{children}
	</Box>
);

HeroWrapper.defaultProps = {
	imageSrc: undefined,
	children: undefined,
	contentProps: undefined
};
